(function() {
    var widgetContainer = document.getElementById('live-update-widget');
    if (!widgetContainer) {
        return;
    }

    var delayTime = 1500;
    var pollingIntervalTime = document.getElementById('live-update-widget-wrapper').getAttribute('data-polling') || 60000;
    var pollingInterval = null;
    var isInitialized = false;
    var isFetching = false;
    var rightDisplacement = '20px';
    var countValue = 0;

    function fetchUpdates(url) {
        if (isFetching) {
            return;
        }
        if (window.innerWidth < 480) {
            rightDisplacement = '0px';
        } else {
            rightDisplacement = '20px';
        }

        isFetching = true;
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'text/html'
            }
        })
        .then(function(response) {
            if (!response.ok) {
                if (response.status === 204) { // No Content
                    // Hide widget and clear content if feed is off
                    var widgetContainer = document.getElementById('live-update-widget');
                    widgetContainer.style.display = 'none';
                    widgetContainer.innerHTML = '';
                    return;
                }
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(function(html) {
            var widgetContainer = document.getElementById('live-update-widget');
            widgetContainer.innerHTML = html;
            widgetContainer.style.display = 'block';
            if(!isInitialized) {
                setTimeout(function() {
                    var widgetContainerWrapper = document.getElementById('live-update-widget-wrapper');
                    widgetContainerWrapper.style.right = rightDisplacement;
                    if(localStorage.getItem('hide_live_widget') === 'true') {
                        _hideLiveWidget();
                    }
                }, delayTime); // Delay to ensure HTMX is ready and make it more dynamic
            } else {
                var widgetContainerWrapper = document.getElementById('live-update-widget-wrapper');
                widgetContainerWrapper.style.right = rightDisplacement;
            }
            isInitialized = true;
            isFetching = false;

            // Determine if there's been a new Winner's Widget entry since last fetch
            // Determined by the count value, if it's higher than we have a new entry and fetch with initialUrl
            var widgetBody = widgetContainer.querySelector('.widget-body');
            if(widgetBody.getAttribute('data-count') != countValue && countValue !== 0) {
                initialUrl = '/live-updates/htmx';
                fetchUpdates(initialUrl);
            }
            countValue = widgetBody.getAttribute('data-count');

        })
        .catch(function(error) {
            console.log('This is the error', error)
            console.error('Error fetching updates:', error);
        });
    }

    // Start polling
    var initialUrl = '/live-updates/htmx';
    fetchUpdates(initialUrl);
    if(localStorage.getItem('hide_live_widget') === null) {
        pollingInterval = setInterval(function() {
            fetchUpdates(initialUrl);
        }, pollingIntervalTime);
    }

    // Cleanup on page unload
    window.addEventListener('beforeunload', function() {
        if (pollingInterval) {
            clearInterval(pollingInterval);
        }
    });

    document.body.addEventListener('htmx:afterOnLoad', function(evt) {
        if (evt.detail.triggerSpec && evt.detail.triggerSpec.includes('every')) {
            // This is a polling update
            const widget = document.getElementById('live-update-widget');
            if (evt.detail.xhr.status === 204) {
                widget.style.display = 'none';
            }
        }
    });

    document.body.addEventListener('showWidget', function(evt) {
        document.getElementById('live-update-widget').style.display = 'block';
    });
    // Add event listeners for prev and next buttons
    document.body.addEventListener('click', function(evt) {
        if (evt.target.matches('.nav-button.prev') || evt.target.matches('.nav-button.next')) {
            var newId = evt.target.getAttribute('data-id');
            if (newId === null) {
                console.log('No data-id attribute found on button');
                return;
            }
            var newUrl = '/live-updates/htmx?id=' + newId;
            initialUrl = newUrl;
            fetchUpdates(newUrl);
        }
    });


    let  liveUpdateClose = document.getElementById('live-update-close-button-click');
    liveUpdateClose.addEventListener('click', function(e){
        _hideLiveWidget();
        localStorage.setItem('hide_live_widget', true);
    });

    let  liveUpdateOpen = document.querySelectorAll('.live-update-open-button-click').forEach(clickArea =>{
        clickArea.addEventListener('click', function(e){
            _showLiveWidget();
            localStorage.removeItem('hide_live_widget');
            pollingInterval = setInterval(function() {
                fetchUpdates(initialUrl);
            }, pollingIntervalTime);
        });
    });



    function _hideLiveWidget() {
        // let  liveUpdateClose = document.getElementById('live-update-close-button-click');
        // liveUpdateClose.style.display = 'none';
        clearInterval(pollingInterval);
        var widgetContainerWrapper = document.getElementById('live-update-widget-wrapper');
        let widgetHeight = widgetContainerWrapper.offsetHeight;
        widgetContainerWrapper.classList.add('hide-live-widget');
        document.getElementById('live-update-widget-wrapper').style.bottom = '-' + (widgetHeight - 50) + 'px';

    }

    function _showLiveWidget() {
        var widgetContainerWrapper = document.getElementById('live-update-widget-wrapper');
        let widgetHeight = widgetContainerWrapper.offsetHeight;
        widgetContainerWrapper.classList.remove('hide-live-widget');
        document.getElementById('live-update-widget-wrapper').style.bottom = '';
    }

})();

